var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundFlagFr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jctu2rgtza)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#039"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "m8bg1lkwrb",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#m8bg1lkwrb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4 24H.435C.195 24 0 23.717 0 23.368V.632C0 .282.195 0 .435 0H8.4v24z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M8.4 0h7.2v24H8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.566 24H15.6V0h7.966c.24 0 .434.283.434.632v22.736c0 .35-.195.632-.434.632z",
    fill: "#FF4B55"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "jctu2rgtza"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundFlagFr);
export default __webpack_public_path__ + "static/media/round-flag-fr.dd8e89c914e915e98bd07f162f9982ea.svg";
export { ForwardRef as ReactComponent };